import React from 'react';

import { Box } from '@components/Restyle';
import { Skeleton } from '@components/shared/Skeleton';
import theme from '@themes/theme';

/**
 * TA-10279: Chat message bubble placeholder — mirrors `ChatMessage.web.tsx`'s
 * row (all web bubbles are left-aligned; sender/receiver differ only by
 * background colour, so one shape covers both): 32x32 avatar + name/time
 * line + a bubble rect. Height target matches `ESTIMATED_ITEM_SIZE = 71`
 * from `ChatMessageList.web.tsx`. Sits on the thread's `grey01` background,
 * so the fill must read against grey01, not white.
 */
export const ChatBubbleSkeleton: React.FC<{ testID?: string }> = ({
  testID = 'chat-bubble-skeleton',
}) => {
  return (
    <Box
      testID={testID}
      flexDirection='row'
      alignItems='flex-start'
      paddingHorizontal='m'
      paddingTop='xxs'
      paddingBottom='xxs'>
      <Skeleton variant='circle' width={32} height={32} />
      <Box flex={1} marginLeft='s' style={{ gap: theme.spacing.xxs }}>
        <Box flexDirection='row' alignItems='center'>
          <Skeleton variant='text' width={70} height={10} />
          <Skeleton
            variant='text'
            width={40}
            height={8}
            style={{ marginLeft: theme.spacing.xxs }}
          />
        </Box>
        <Skeleton
          variant='rect'
          width='60%'
          height={36}
          borderRadius='s'
          style={{ borderTopLeftRadius: 0 }}
        />
      </Box>
    </Box>
  );
};
